/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import Button, { IconButton } from '@atlaskit/button/new';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CrossIcon from '@atlaskit/icon/core/cross';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const styles = cssMap({
	wrapper: {
		boxSizing: 'border-box',
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
	},
	iconContainer: {
		width: '24px',
		height: '24px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	content: {
		display: 'flex',
		alignItems: 'center',
		columnGap: token('space.100'),
		flex: 1,
	},
	buttonGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.100'),
	},
});

export type RovoThinkingReadyProps = {
	onView?: () => void;
	onClose: () => void;
	readyText?: string;
};

export function RovoThinkingReady({
	onView,
	onClose,
	readyText,
}: RovoThinkingReadyProps): JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<div css={styles.wrapper}>
			<div css={styles.content}>
				<div css={styles.iconContainer}>
					<CheckCircleIcon label="" color={token('color.icon.success')} />
				</div>
				<Text>{readyText ?? formatMessage(messages.thinkingReadyMessage)}</Text>
			</div>
			<div css={styles.buttonGroup}>
				{onView && (
					<Button appearance="primary" onClick={onView} testId="thinking-ready-view-button">
						{formatMessage(messages.thinkingReadyView)}
					</Button>
				)}
				<IconButton
					appearance="subtle"
					spacing={!!onView || !fg('rovo_ready_bar_fix_height') ? 'compact' : 'default'}
					onClick={onClose}
					testId="thinking-ready-close-button"
					label={formatMessage(messages.thinkingReadyClose)}
					icon={CrossIcon}
				/>
			</div>
		</div>
	);
}
